import { module } from 'modujs';


export default class extends module {
    constructor(m) {
        super(m);
        this.carousel = this.$('carousel')[0]
        if(!this.carousel) this.carousel = this.el

        this.arrowNext = this.$('next')[0]
        this.arrowPrev = this.$('prev')[0]
    }

    init() {
        this.length = this.$('item').length

        const args = {
            speed: 1000,
            loop: true,
            spaceBetween: 0,
            loopedSlides: 2,
            grabCursor: true,
            slidesPerView: 1,
            threshold: 2,
            parallax: true,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev,
            },
            breakpoints: {
                700: {
                    slidesPerView: 2,
                }
            },
            on: {
                slideChangeTransitionEnd: () => {
                    this.swiper?.lazy?.load?.()
                }
            }
        }

        let viewportWidth = window.innerWidth || document.documentElement.clientWidth;

        if (viewportWidth < 700) {
            if(this.length > 0) {
                this.carousel = new Swiper(this.carousel, args)
                this.arrowPrev.classList.remove('is-invisible')
                this.arrowNext.classList.remove('is-invisible')
            }
        } else {
            if(this.length > 1) {
                this.carousel = new Swiper(this.carousel, args)
                this.arrowPrev.classList.remove('is-invisible')
                this.arrowNext.classList.remove('is-invisible')
            }
        }
    }

    inview(e) {
        if(e.obj.el == this.el) {
            this.swiper.lazy.load()
        }
    }

    destroy() {
        if(this.carousel && this.carousel.destroy) this.carousel.destroy(true, true)
    }
}
